module.exports = __webpack_public_path__ + "img/colour-turmeric.4e7cb456.png";